import { render, staticRenderFns } from "./IconWinter.vue?vue&type=template&id=671617b2&scoped=true"
import script from "./IconWinter.vue?vue&type=script&lang=ts"
export * from "./IconWinter.vue?vue&type=script&lang=ts"
import style0 from "./IconWinter.vue?vue&type=style&index=0&id=671617b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671617b2",
  null
  
)

export default component.exports